import { useSetRecoilState } from "recoil";
import { navigationTargetState } from "../../../../../recoil/store";
import { usePubContext } from "../../hooks/pub-context";
import {
  PremiumPubLocationButton,
  PremiumPubLocationText,
  PremiumPubLocationWrapper,
} from "./style";
import { useEffect } from "react";
import { renderToString } from "react-dom/server";
import StoreMarker from "../../../../../components/StoreMarker";

const PremiumPubLocation = () => {
  const { data } = usePubContext();
  const setNavigationTarget = useSetRecoilState(navigationTargetState);

  useEffect(() => {
    if (!data) return;
    const mapDiv = document.getElementById("map") as HTMLDivElement;

    const NaverMaps = window.naver.maps;
    const map = new NaverMaps.Map(mapDiv, {
      center: new NaverMaps.LatLng(data.lat, data.lon),
      tileSpare: 3,
    });

    new NaverMaps.Marker({
      position: new NaverMaps.LatLng(data.lat, data.lon),
      map: map,
      title: data.cafeName,
      icon: {
        content: renderToString(
          <StoreMarker
            selected
            pubType={data.pubType}
            buyInFrom={data.buyIn}
            buyInTo={data.buyInMax}
            name={data.cafeName}
          />
        ),
        anchor: new NaverMaps.Point(0, 30),
      },
    });
  }, []);

  return (
    <PremiumPubLocationWrapper>
      <div className="title">매장 위치</div>
      <div id="map" />
      <PremiumPubLocationText>
        <img src="/image-web/store/Map%20pin/small.png" alt="map" />
        <span>
          {data?.newAddress} {data?.detailAddress}
        </span>
      </PremiumPubLocationText>
      <PremiumPubLocationButton
        onClick={() => data && setNavigationTarget(data)}
      >
        <img src="/image-web/Icon/Navigation-white.svg" alt="navigation" />
        <span>길안내</span>
      </PremiumPubLocationButton>
    </PremiumPubLocationWrapper>
  );
};
export default PremiumPubLocation;
